@use "styles/mixins/_rem.scss" as rem;

.image-preview-shell {
  position: absolute;
  width: rem.torem(92px);
  z-index: 1;
}

.image-preview-offer-preview {
  background-color: var(--color-background-default);
  border-radius: var(--size-border-radius-s);
  left: rem.torem(0);
  position: absolute;
  top: rem.torem(0);
  width: rem.torem(92px);
}
